import angular from "angular";

angular
    .module('app')
    .component('parametersControl', {
        template: require('./parameters-control.html'),
        controller: ['$http', '$timeout', 'ErrorResponseParser', 'Notifier', 'Upload', '$sce', controller],
        bindings: {}
    });

function controller($http, $timeout, ErrorResponseParser, Notifier, Upload, $sce) {

    let $ctrl = this;

    // $ctrl.phoneMasks = [
    //     {country: 'Kazakhstan', country_code: 'KZ', phone_code: '+7', phone_mask: '+7 (999) 999-99-99'},
    //     {country: 'Usa', country_code: 'USA', phone_code: '+1', phone_mask: '+1 (999) 999-99-99'},
    //     {country: 'UAE', country_code: 'UAE', phone_code: '+971', phone_mask: '+\\971 (999) 99-9999'},
    //     {country: 'SPAIN', country_code: 'SPA', phone_code: '+34', phone_mask: '+34 (999) 999-999'}
    // ];

    // $ctrl.selectedMask = $ctrl.phoneMasks[0];

    $ctrl.$onInit = function () {
        $ctrl.logo = null;
        $ctrl.logoUrl = null;
        $ctrl.favicon = null;
        $ctrl.faviconUrl = null;
        $ctrl.theme = 'standard';
        $ctrl.phoneMask = '+7 (999) 999-99-99';
        $ctrl.getList();
    };

    // $ctrl.maskChanged = function () {
    //     $ctrl.phone = null;
    // };

    $ctrl.getList = function () {
        $http
            .get('/admin/organization-parameters/get-list')
            .then(
                function (response) {
                    response.data.forEach(function (parameter, parameterId) {
                        if (parameter.key === 'logo_path') {
                            $ctrl.logoUrl = parameter.logoUrl;
                        } else
                        if (parameter.key === 'favicon_path') {
                            $ctrl.faviconUrl = parameter.faviconUrl;
                        } else
                        if (parameter.key === 'title') {
                            $ctrl.title = parameter.value;
                        } else
                        if (parameter.key === 'email') {
                            $ctrl.email = parameter.value;
                        } else
                        if (parameter.key === 'phone') {
                            $ctrl.phone = parameter.value.slice(1);
                        } else
                        if (parameter.key === 'site_theme') {
                            $ctrl.theme = parameter.value;
                        }

                    });

                },
                function (error) {
                    console.log(error);
                }
            );
    };

    $ctrl.updateOrganizationData = function () {
        $ctrl.loading = true;
        Upload
            .upload({
                url: '/admin/organization-parameters/update-organization-data',
                data: {
                    logo: $ctrl.logo,
                    favicon: $ctrl.favicon,
                    title: $ctrl.title ? $ctrl.title : undefined,
                    email: $ctrl.email ? $ctrl.email : undefined,
                    phone: $ctrl.phone ? $ctrl.phone.replace(/\D/g, '') : undefined,
                    theme: $ctrl.theme ? $ctrl.theme : undefined,

                },
            })
            .then(
                function (response) {
                    $ctrl.loading = false;
                    if (response.data.logoUrl) {
                        $ctrl.logoUrl = response.data.logoUrl;
                    }
                    if (response.data.faviconUrl) {
                        $ctrl.faviconUrl = response.data.faviconUrl;
                    }
                    Notifier.success('Данные успешно обновлены', 2);

                },
                function (error) {
                    Notifier.error('Произошла ошибка', 2);
                },
                function (evt) {
                }
            );
    }
}
